import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "../../pages/Home";
import Employees from "../../pages/Employees";
import Companies from "../../pages/Companies";
import Departments from "../../pages/Departments";
import Positions from "../../pages/Positions";
import Meetings from "../../pages/Meetings";
import Admins from "../../pages/Admins";
import MyProfile from "../../pages/MyProfile";
import MeetingRooms from "../../pages/MeetingRooms";
import CompanyEdit from "../../pages/CompanyEdit";
import DepartmentEdit from "../../pages/DepartmentEdit";
import PositionEdit from "../../pages/PositionEdit";
import EmployeeEdit from "../../pages/EmployeeEdit";
import MeetingRoomEdit from "../../pages/MeetingRoomEdit";
import MeetingAdd from "../../pages/MeetingAdd";
import MeetingOverview from "../../pages/MeetingOverview";
import MeetingEdit from "../../pages/MeetingEdit";
import Login from "../../pages/Login";

const MainRoute = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/companies" element={<Companies />} />
      <Route path="/departments" element={<Departments />} />
      <Route path="/positions" element={<Positions />} />
      <Route path="/employees" element={<Employees />} />
      <Route path="/meetingrooms" element={<MeetingRooms />} />
      <Route path="/meetings" element={<Meetings />} />
      <Route path="/addmeeting" element={<MeetingAdd />} />
      <Route path="/admins" element={<Admins />} />
      <Route path="/profile" element={<MyProfile />} />

      <Route path="/companyedit" element={<CompanyEdit />} />
      <Route path="/departmentedit" element={<DepartmentEdit />} />
      <Route path="/positionedit" element={<PositionEdit />} />
      <Route path="/employeeedit" element={<EmployeeEdit />} />
      <Route path="/meetingroomedit" element={<MeetingRoomEdit />} />
      <Route path="/meetingoverview" element={<MeetingOverview />} />
      <Route path="/meetingedit" element={<MeetingEdit />} />

      <Route path="/login" element={<Login />} />
    </Routes>
  );
};

export default MainRoute;
